"use client";

import { Lightning } from "@phosphor-icons/react";
import { useContext } from "react";
import { AuthContext } from "@/context/auth-context";
import { SubscriptionPlan } from "@/types";

export default function ProBadge() {
  const { user } = useContext(AuthContext);

  if (!user?.subscription) return null;

  return (
    <div className="flex items-center">
          {user.subscription.plan === SubscriptionPlan.Boss ? (
                <span className="inline-flex items-center gap-2 px-3 py-1 text-sm font-semibold text-blue-700 bg-blue-100 rounded-full">
              <Lightning weight="duotone" className="w-4 h-4" />
              BOSS
            </span>
          ) : user.subscription.plan === SubscriptionPlan.Goat ? (
            <span className="inline-flex items-center gap-2 px-3 py-1 text-sm font-semibold text-green-700 bg-green-100 rounded-full">
              <Lightning weight="duotone" className="w-4 h-4" />
              G.O.A.T.
            </span>
          ) : null}
    </div>
  );
} 